// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Viewport-safe dialogs: tall modals stay reachable via backdrop scroll + safe-area.
 * Import this stylesheet LAST after main, bar-owner, artist, notifications-messaging.
 * - max-width 768px: mobile refinements (below).
 * - min-width 769px: desktop backdrop scroll (mirrors mobile overlay behavior; mobile-only
 *   new-message dropdown tweaks stay inside the max-width block only).
 */

@media (max-width: 768px) {
  /*
   * Dialog overlays that wrap centered content with flex (scroll the backdrop).
   * Omit full-screen loaders: calendar-loading-overlay, mobile-overlay,
   * logout-in-progress-overlay, photo-upload-progress-overlay,
   * availability-saving-overlay, add-show-modal-busy-overlay, deleted-overlay.
   */
  .artist-profile-modal-overlay,
  .invite-response-modal-overlay,
  .confirm-modal-overlay,
  .show-card-modal-overlay,
  .add-show-modal-overlay,
  .bar-management-modal-overlay,
  .bar-modal-overlay,
  .bar-modal-artist-selector-overlay {
    align-items: flex-start;
    justify-content: center;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: max(12px, env(safe-area-inset-top));
    padding-right: max(12px, env(safe-area-inset-right));
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    padding-left: max(12px, env(safe-area-inset-left));
    box-sizing: border-box;
    min-height: 100dvh;
    min-height: 100vh;
  }

  /* Modal overlay used as sibling click-catcher next to \`.modal-container\` — still scroll-safe */
  .modal-overlay {
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    align-items: flex-start;
    justify-content: center;
    padding-top: max(12px, env(safe-area-inset-top));
    padding-right: max(12px, env(safe-area-inset-right));
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    padding-left: max(12px, env(safe-area-inset-left));
    box-sizing: border-box;
    display: flex;
    min-height: 100dvh;
    min-height: 100vh;
  }

  /*
   * Let dialog shells grow with content so the overlay is the vertical scroll surface.
   */
  .artist-profile-modal-overlay .artist-profile-modal,
  .invite-response-modal-overlay .invite-response-modal {
    max-height: none;
    width: 100%;
    box-sizing: border-box;
  }

  .confirm-modal-overlay .confirm-modal {
    max-height: none;
    box-sizing: border-box;
  }

  .show-card-modal-overlay .show-card-modal {
    max-height: none;
    box-sizing: border-box;
  }

  .add-show-modal-overlay .add-show-modal {
    max-height: none;
    box-sizing: border-box;
  }

  .bar-management-modal-overlay .bar-management-modal-container {
    max-height: none;
    box-sizing: border-box;
  }

  .bar-modal-overlay .bar-modal {
    max-height: none;
    box-sizing: border-box;
  }

  .bar-modal-artist-selector-overlay .bar-modal-artist-selector {
    max-height: none;
    box-sizing: border-box;
    width: calc(100% - 24px);
    max-width: 400px;
  }

  /*
   * Sibling pattern: \`.modal-overlay\` + \`.modal-container\` (both fixed).
   * Pin panel to safe-area inset so inner overflow-y reaches footer actions.
   */
  .modal-container {
    position: fixed;
    top: max(12px, env(safe-area-inset-top));
    right: max(12px, env(safe-area-inset-right));
    bottom: max(12px, env(safe-area-inset-bottom));
    left: max(12px, env(safe-area-inset-left));
    transform: none;
    width: auto;
    max-width: none;
    max-height: none;
    margin: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
  }

  /*
   * New message UI: fixed centered sheet — convert to inset sheet with internal scroll.
   */
  .new-message-dropdown {
    position: fixed;
    top: max(12px, env(safe-area-inset-top));
    right: max(12px, env(safe-area-inset-right));
    bottom: max(12px, env(safe-area-inset-bottom));
    left: max(12px, env(safe-area-inset-left));
    transform: none;
    width: auto;
    max-width: none;
    max-height: none;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    animation: none;
    box-sizing: border-box;
  }

  /*
   * iOS Safari zooms the visual viewport when focusing inputs with font-size < 16px,
   * and the zoom can persist (horizontal scroll) after the modal closes. Use 16px here.
   */
  .new-message-search-input,
  .new-message-group-name {
    font-size: 16px;
  }

  .new-message-dropdown-footer {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 0.75rem;
  }

  .new-message-cancel-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    padding: 0.75rem 1rem;
    min-height: 44px;
    box-sizing: border-box;
    background: transparent;
    color: var(--primary-red);
    border: 2px solid var(--primary-red);
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
    -webkit-tap-highlight-color: transparent;
  }

  .new-message-cancel-btn:hover {
    background: var(--primary-red);
    color: var(--text-white);
    box-shadow: var(--shadow-red);
  }

  .new-message-cancel-btn:active {
    opacity: 0.92;
  }

  .new-message-start-btn {
    flex: 1;
    width: auto;
    min-width: 0;
  }

  /* Long strings / URLs in common modal bodies */
  .confirm-modal-body,
  .confirm-modal-body p,
  .modal-content,
  .modal-show-details,
  .invite-response-modal .detail-value,
  .artist-profile-modal-body {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
}

@media (min-width: 769px) {
  /*
   * Desktop: same backdrop scroll as mobile — omit full-screen loaders (see mobile block).
   */
  .artist-profile-modal-overlay,
  .invite-response-modal-overlay,
  .confirm-modal-overlay,
  .show-card-modal-overlay,
  .add-show-modal-overlay,
  .bar-management-modal-overlay,
  .bar-modal-overlay,
  .bar-modal-artist-selector-overlay {
    align-items: flex-start;
    justify-content: center;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: max(12px, env(safe-area-inset-top));
    padding-right: max(12px, env(safe-area-inset-right));
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    padding-left: max(12px, env(safe-area-inset-left));
    box-sizing: border-box;
    min-height: 100dvh;
    min-height: 100vh;
  }

  .modal-overlay {
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    align-items: flex-start;
    justify-content: center;
    padding-top: max(12px, env(safe-area-inset-top));
    padding-right: max(12px, env(safe-area-inset-right));
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    padding-left: max(12px, env(safe-area-inset-left));
    box-sizing: border-box;
    display: flex;
    min-height: 100dvh;
    min-height: 100vh;
  }

  .artist-profile-modal-overlay .artist-profile-modal,
  .invite-response-modal-overlay .invite-response-modal {
    max-height: none;
    width: 100%;
    box-sizing: border-box;
  }

  .confirm-modal-overlay .confirm-modal {
    max-height: none;
    box-sizing: border-box;
  }

  .show-card-modal-overlay .show-card-modal {
    max-height: none;
    box-sizing: border-box;
  }

  .add-show-modal-overlay .add-show-modal {
    max-height: none;
    box-sizing: border-box;
  }

  .bar-management-modal-overlay .bar-management-modal-container {
    max-height: none;
    box-sizing: border-box;
  }

  .bar-modal-overlay .bar-modal {
    max-height: none;
    box-sizing: border-box;
  }

  .bar-modal-artist-selector-overlay .bar-modal-artist-selector {
    max-height: none;
    box-sizing: border-box;
    width: calc(100% - 24px);
    max-width: 400px;
  }

  .modal-container {
    position: fixed;
    top: max(12px, env(safe-area-inset-top));
    right: max(12px, env(safe-area-inset-right));
    bottom: max(12px, env(safe-area-inset-bottom));
    left: max(12px, env(safe-area-inset-left));
    transform: none;
    width: auto;
    max-width: none;
    max-height: none;
    margin: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
  }

  /*
   * Calendar day-detail (bar-owner + artist): keep a centered, readable width on desktop.
   * Do not use the full-inset sibling-panel layout above (mobile-first sheet).
   */
  .modal-container.calendar-day-detail-modal {
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
    width: min(560px, calc(100vw - 48px));
    max-width: min(560px, calc(100vw - 48px));
    max-height: min(85vh, calc(100vh - 48px));
    max-height: min(85dvh, calc(100dvh - 48px));
  }

  .confirm-modal-body,
  .confirm-modal-body p,
  .modal-content,
  .modal-show-details,
  .invite-response-modal .detail-value,
  .artist-profile-modal-body {
    overflow-wrap: anywhere;
    word-break: break-word;
  }
}

/* Calendar day-detail: bar-owner \`.modal-container\` uses modalSlideIn; keyframes override
   transform and cause a visible snap vs. mobile inset layout. Other modals keep the animation. */
.modal-container.calendar-day-detail-modal {
  animation: none;
}
`, "",{"version":3,"sources":["webpack://./client/styles/modals-mobile.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE;;;;;IAKE;EACF;;;;;;;;IAQE,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,gDAAgD;IAChD,oDAAoD;IACpD,sDAAsD;IACtD,kDAAkD;IAClD,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,+FAA+F;EAC/F;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,uBAAuB;IACvB,uBAAuB;IACvB,gDAAgD;IAChD,oDAAoD;IACpD,sDAAsD;IACtD,kDAAkD;IAClD,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE;EACF;;IAEE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;;;IAGE;EACF;IACE,eAAe;IACf,wCAAwC;IACxC,4CAA4C;IAC5C,8CAA8C;IAC9C,0CAA0C;IAC1C,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA;;IAEE;EACF;IACE,eAAe;IACf,wCAAwC;IACxC,4CAA4C;IAC5C,8CAA8C;IAC9C,0CAA0C;IAC1C,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,sBAAsB;EACxB;;EAEA;;;IAGE;EACF;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,uEAAuE;IACvE,wCAAwC;EAC1C;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,OAAO;IACP,WAAW;IACX,YAAY;EACd;;EAEA,+CAA+C;EAC/C;;;;;;IAME,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE;EACF;;;;;;;;IAQE,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,gDAAgD;IAChD,oDAAoD;IACpD,sDAAsD;IACtD,kDAAkD;IAClD,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,uBAAuB;IACvB,uBAAuB;IACvB,gDAAgD;IAChD,oDAAoD;IACpD,sDAAsD;IACtD,kDAAkD;IAClD,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,wCAAwC;IACxC,4CAA4C;IAC5C,8CAA8C;IAC9C,0CAA0C;IAC1C,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA;;;IAGE;EACF;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,qCAAqC;IACrC,yCAAyC;IACzC,yCAAyC;IACzC,2CAA2C;EAC7C;;EAEA;;;;;;IAME,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;iGACiG;AACjG;EACE,eAAe;AACjB","sourcesContent":["/**\n * Viewport-safe dialogs: tall modals stay reachable via backdrop scroll + safe-area.\n * Import this stylesheet LAST after main, bar-owner, artist, notifications-messaging.\n * - max-width 768px: mobile refinements (below).\n * - min-width 769px: desktop backdrop scroll (mirrors mobile overlay behavior; mobile-only\n *   new-message dropdown tweaks stay inside the max-width block only).\n */\n\n@media (max-width: 768px) {\n  /*\n   * Dialog overlays that wrap centered content with flex (scroll the backdrop).\n   * Omit full-screen loaders: calendar-loading-overlay, mobile-overlay,\n   * logout-in-progress-overlay, photo-upload-progress-overlay,\n   * availability-saving-overlay, add-show-modal-busy-overlay, deleted-overlay.\n   */\n  .artist-profile-modal-overlay,\n  .invite-response-modal-overlay,\n  .confirm-modal-overlay,\n  .show-card-modal-overlay,\n  .add-show-modal-overlay,\n  .bar-management-modal-overlay,\n  .bar-modal-overlay,\n  .bar-modal-artist-selector-overlay {\n    align-items: flex-start;\n    justify-content: center;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-top: max(12px, env(safe-area-inset-top));\n    padding-right: max(12px, env(safe-area-inset-right));\n    padding-bottom: max(12px, env(safe-area-inset-bottom));\n    padding-left: max(12px, env(safe-area-inset-left));\n    box-sizing: border-box;\n    min-height: 100dvh;\n    min-height: 100vh;\n  }\n\n  /* Modal overlay used as sibling click-catcher next to `.modal-container` — still scroll-safe */\n  .modal-overlay {\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    align-items: flex-start;\n    justify-content: center;\n    padding-top: max(12px, env(safe-area-inset-top));\n    padding-right: max(12px, env(safe-area-inset-right));\n    padding-bottom: max(12px, env(safe-area-inset-bottom));\n    padding-left: max(12px, env(safe-area-inset-left));\n    box-sizing: border-box;\n    display: flex;\n    min-height: 100dvh;\n    min-height: 100vh;\n  }\n\n  /*\n   * Let dialog shells grow with content so the overlay is the vertical scroll surface.\n   */\n  .artist-profile-modal-overlay .artist-profile-modal,\n  .invite-response-modal-overlay .invite-response-modal {\n    max-height: none;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .confirm-modal-overlay .confirm-modal {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .show-card-modal-overlay .show-card-modal {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .add-show-modal-overlay .add-show-modal {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .bar-management-modal-overlay .bar-management-modal-container {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .bar-modal-overlay .bar-modal {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .bar-modal-artist-selector-overlay .bar-modal-artist-selector {\n    max-height: none;\n    box-sizing: border-box;\n    width: calc(100% - 24px);\n    max-width: 400px;\n  }\n\n  /*\n   * Sibling pattern: `.modal-overlay` + `.modal-container` (both fixed).\n   * Pin panel to safe-area inset so inner overflow-y reaches footer actions.\n   */\n  .modal-container {\n    position: fixed;\n    top: max(12px, env(safe-area-inset-top));\n    right: max(12px, env(safe-area-inset-right));\n    bottom: max(12px, env(safe-area-inset-bottom));\n    left: max(12px, env(safe-area-inset-left));\n    transform: none;\n    width: auto;\n    max-width: none;\n    max-height: none;\n    margin: 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    box-sizing: border-box;\n  }\n\n  /*\n   * New message UI: fixed centered sheet — convert to inset sheet with internal scroll.\n   */\n  .new-message-dropdown {\n    position: fixed;\n    top: max(12px, env(safe-area-inset-top));\n    right: max(12px, env(safe-area-inset-right));\n    bottom: max(12px, env(safe-area-inset-bottom));\n    left: max(12px, env(safe-area-inset-left));\n    transform: none;\n    width: auto;\n    max-width: none;\n    max-height: none;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    animation: none;\n    box-sizing: border-box;\n  }\n\n  /*\n   * iOS Safari zooms the visual viewport when focusing inputs with font-size < 16px,\n   * and the zoom can persist (horizontal scroll) after the modal closes. Use 16px here.\n   */\n  .new-message-search-input,\n  .new-message-group-name {\n    font-size: 16px;\n  }\n\n  .new-message-dropdown-footer {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0.75rem;\n  }\n\n  .new-message-cancel-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 auto;\n    padding: 0.75rem 1rem;\n    min-height: 44px;\n    box-sizing: border-box;\n    background: transparent;\n    color: var(--primary-red);\n    border: 2px solid var(--primary-red);\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 0.95rem;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .new-message-cancel-btn:hover {\n    background: var(--primary-red);\n    color: var(--text-white);\n    box-shadow: var(--shadow-red);\n  }\n\n  .new-message-cancel-btn:active {\n    opacity: 0.92;\n  }\n\n  .new-message-start-btn {\n    flex: 1;\n    width: auto;\n    min-width: 0;\n  }\n\n  /* Long strings / URLs in common modal bodies */\n  .confirm-modal-body,\n  .confirm-modal-body p,\n  .modal-content,\n  .modal-show-details,\n  .invite-response-modal .detail-value,\n  .artist-profile-modal-body {\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n}\n\n@media (min-width: 769px) {\n  /*\n   * Desktop: same backdrop scroll as mobile — omit full-screen loaders (see mobile block).\n   */\n  .artist-profile-modal-overlay,\n  .invite-response-modal-overlay,\n  .confirm-modal-overlay,\n  .show-card-modal-overlay,\n  .add-show-modal-overlay,\n  .bar-management-modal-overlay,\n  .bar-modal-overlay,\n  .bar-modal-artist-selector-overlay {\n    align-items: flex-start;\n    justify-content: center;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    padding-top: max(12px, env(safe-area-inset-top));\n    padding-right: max(12px, env(safe-area-inset-right));\n    padding-bottom: max(12px, env(safe-area-inset-bottom));\n    padding-left: max(12px, env(safe-area-inset-left));\n    box-sizing: border-box;\n    min-height: 100dvh;\n    min-height: 100vh;\n  }\n\n  .modal-overlay {\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    align-items: flex-start;\n    justify-content: center;\n    padding-top: max(12px, env(safe-area-inset-top));\n    padding-right: max(12px, env(safe-area-inset-right));\n    padding-bottom: max(12px, env(safe-area-inset-bottom));\n    padding-left: max(12px, env(safe-area-inset-left));\n    box-sizing: border-box;\n    display: flex;\n    min-height: 100dvh;\n    min-height: 100vh;\n  }\n\n  .artist-profile-modal-overlay .artist-profile-modal,\n  .invite-response-modal-overlay .invite-response-modal {\n    max-height: none;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .confirm-modal-overlay .confirm-modal {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .show-card-modal-overlay .show-card-modal {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .add-show-modal-overlay .add-show-modal {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .bar-management-modal-overlay .bar-management-modal-container {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .bar-modal-overlay .bar-modal {\n    max-height: none;\n    box-sizing: border-box;\n  }\n\n  .bar-modal-artist-selector-overlay .bar-modal-artist-selector {\n    max-height: none;\n    box-sizing: border-box;\n    width: calc(100% - 24px);\n    max-width: 400px;\n  }\n\n  .modal-container {\n    position: fixed;\n    top: max(12px, env(safe-area-inset-top));\n    right: max(12px, env(safe-area-inset-right));\n    bottom: max(12px, env(safe-area-inset-bottom));\n    left: max(12px, env(safe-area-inset-left));\n    transform: none;\n    width: auto;\n    max-width: none;\n    max-height: none;\n    margin: 0;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    box-sizing: border-box;\n  }\n\n  /*\n   * Calendar day-detail (bar-owner + artist): keep a centered, readable width on desktop.\n   * Do not use the full-inset sibling-panel layout above (mobile-first sheet).\n   */\n  .modal-container.calendar-day-detail-modal {\n    top: 50%;\n    left: 50%;\n    right: auto;\n    bottom: auto;\n    transform: translate(-50%, -50%);\n    width: min(560px, calc(100vw - 48px));\n    max-width: min(560px, calc(100vw - 48px));\n    max-height: min(85vh, calc(100vh - 48px));\n    max-height: min(85dvh, calc(100dvh - 48px));\n  }\n\n  .confirm-modal-body,\n  .confirm-modal-body p,\n  .modal-content,\n  .modal-show-details,\n  .invite-response-modal .detail-value,\n  .artist-profile-modal-body {\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n}\n\n/* Calendar day-detail: bar-owner `.modal-container` uses modalSlideIn; keyframes override\n   transform and cause a visible snap vs. mobile inset layout. Other modals keep the animation. */\n.modal-container.calendar-day-detail-modal {\n  animation: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
